import { UpCircleFilled, UpCircleOutlined } from "@ant-design/icons"
import { Typography, message } from "antd"
import { doc, serverTimestamp, updateDoc } from "firebase/firestore"
import React, { useEffect, useState } from "react"
import { db } from "../../../../firebase/config"

const { Link } = Typography

export default function MakePriorityJob({ data }) {
  const [priority, setPriority] = useState(false)

  useEffect(() => {
    if (data.priorityOrder) {
      setPriority(true)
    } else {
      setPriority(false)
    }
  }, [data])

  const makePriority = async () => {
    const ref = doc(db, "orders", data.id)

    try {
      await updateDoc(ref, {
        priorityOrder: true,
        priorityOrderUpdate: serverTimestamp(),
      }).then(() => {
        message.success("made priority")
      })
    } catch (err) {
      message.error("error happened")
      console.log(err)
    }
  }

  const removePriority = async () => {
    const ref = doc(db, "orders", data.id)

    try {
      await updateDoc(ref, {
        priorityOrder: false,
        priorityOrderUpdate: serverTimestamp(),
      }).then(() => {
        message.warning("priority removed")
      })
    } catch (err) {
      message.error("error happened")
      console.log(err)
    }
  }

  if (priority) {
    return (
      <>
        <Link onClick={() => removePriority()}>
          <UpCircleFilled style={{ color: "#f5222d" }} />
        </Link>
      </>
    )
  } else {
    return (
      <>
        <Link onClick={() => makePriority()}>
          <UpCircleOutlined />
        </Link>
      </>
    )
  }
}
